module.exports = __webpack_public_path__ + "img/s.c3f76493.jpg";